import React from 'react';
import { StaticImage } from "gatsby-plugin-image"

const NewsletterForm = ({
  title,
  mailchimpUrl,
  mailchimpTag,
  firstNamePlaceholder,
  lastNamePlaceholder,
  emailPlaceholder,
  buttonText,
  minimise,
}) => (
  <div className={`rs-newsletter style1 newsletter-home6-style ${!minimise && 'mt-20 mb-20'} md-mt-15 md-mb-15`}>
    <div className={`newsletter-wrap ${minimise ? 'small' : ''}`}>
      <div className='row y-middle'>
        <div className={`md-mb-30 col-lg-${minimise ? '12' : '6'}`}>
          <div className='content-wrap'>
            {!minimise && (
              <StaticImage
                src="../../images/contact/icons/mail.png"
                loading="eager"
                alt="speech bubbles icon"
                placeholder="none"
                style={{ width: 75, marginRight: 20, opacity: 0.1 }}
              />
            )}
            <h3 className={`newsletter-title ${minimise ? 'small' : ''}`}>
              {title}
            </h3>
          </div>
        </div>
        <div className={`col-lg-${minimise ? '12' : '6'}`}>
          <form
            className={`newsletter-form ${minimise ? 'small' : ''}`}
            // action='https://xyz.us21.list-manage.com/subscribe/post?u=085f45fd52c0e578bf1635f71&amp;id=da7ed97d81&amp;f_id=0049a3e1f0'
            action={mailchimpUrl}
            method='post'
            target='_blank'
          >
            {/* <input type='hidden' name='tags' value='442415' /> */}
            <input type='hidden' name='tags' value={mailchimpTag} />
            <div className='row'>
              <div className={`${minimise ? 'col-lg-6' : ''}`}>
                <input type='text' name='FNAME' placeholder={firstNamePlaceholder} required='' />
                <input type='text' name='LNAME' placeholder={lastNamePlaceholder} required='' />
              </div>
              <div className={`${minimise ? 'col-lg-6' : ''}`}>
                <input type='email' name='EMAIL' placeholder={emailPlaceholder} required='' />
                <button type='submit' className='paper-plane'>
                  {buttonText}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
);

export default NewsletterForm;
